import { Filter } from '../../../../components/Filters/Filter';
import { useTranslation } from 'react-i18next';
import { PlatformChooser } from './choosers/PlatformChooser';
import { CountriesChooser } from './choosers/CountriesChooser';
import { AffiliationCountriesChooser } from './choosers/AffiliationCountriesChooser';
import { BotsChooser } from './choosers/BotsChooser';
import { IoCChooser } from './choosers/IoCChooser';
import { AudienceChooser } from './choosers/AudienceChooser';
import { GeoGroupChooser } from './choosers/GeoGroupChooser';
import { useBreakdownsFilterContext, getEmptyBreakdownsFilterState } from './BreakdownsFilterContext';

export const BreakdownsFilter = () => {
  const { t } = useTranslation();
  const { state, updateDraftFilters, applyDraftFilters } = useBreakdownsFilterContext();

  const filterContent = [
    {
      name: t('Platforms'),
      count: state.draftFilters.platforms.value.length,
      content: <PlatformChooser />,
      isExclude: state.draftFilters.platforms.exclude,
    },
    {
      name: t('Actor origin countries'),
      count: state.draftFilters.countries.value.length,
      content: <CountriesChooser />,
      isExclude: state.draftFilters.countries.exclude,
    },
    {
      name: t('Audience'),
      count: state.draftFilters.audience.value[0] > 0 || state.draftFilters.audience.value[1] < 1000000000 ? 1 : 0,
      content: <AudienceChooser />,
      isExclude: state.draftFilters.audience.exclude,
    },
    {
      name: t('Actor origin country groups'),
      count: state.draftFilters.geoGroup.value.length,
      content: <GeoGroupChooser />,
      isExclude: state.draftFilters.geoGroup.exclude,
    },
    {
      name: t('State-affiliated'),
      count: state.draftFilters.affiliations.value.length,
      content: <AffiliationCountriesChooser />,
      isExclude: state.draftFilters.affiliations.exclude,
    },
    {
      name: t('High risk accounts'),
      count: state.draftFilters.discreditations.value.length,
      content: <IoCChooser />,
      isExclude: state.draftFilters.discreditations.exclude,
    },
    {
      name: t('Inauthentic behavior'),
      count: state.draftFilters.bots.value === null ? 0 : 1,
      content: <BotsChooser />,
      isExclude: state.draftFilters.bots.exclude,
    },
  ];

  return (
    <Filter
      onClearAll={() => {
        const emptyFilters = getEmptyBreakdownsFilterState();
        updateDraftFilters(emptyFilters);
        applyDraftFilters();
      }}
      content={filterContent}
    />
  );
};
